import { render, staticRenderFns } from "./DynamicTags.vue?vue&type=template&id=5c92d021&"
import script from "./DynamicTags.vue?vue&type=script&lang=js&"
export * from "./DynamicTags.vue?vue&type=script&lang=js&"
import style0 from "./DynamicTags.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DynamicTags.vue"
export default component.exports